/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Not_Found_Default_DescriptionInputs */

const en_components_not_found_default_description = /** @type {(inputs: Components_Not_Found_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This page was delisted — or it never traded here in the first place. Check the address, or head back to safety.`)
};

const de_components_not_found_default_description = /** @type {(inputs: Components_Not_Found_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Seite wurde delistet – oder sie wurde hier nie gehandelt. Prüfen Sie die Adresse oder kehren Sie zur Startseite zurück.`)
};

const pt_br2_components_not_found_default_description = /** @type {(inputs: Components_Not_Found_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta página foi deslistada — ou nunca foi negociada por aqui. Confira o endereço ou volte para o início.`)
};

const tr_components_not_found_default_description = /** @type {(inputs: Components_Not_Found_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu sayfa listeden kaldırıldı — ya da burada hiç işlem görmedi. Adresi kontrol edin veya ana sayfaya dönün.`)
};

const zh_cn2_components_not_found_default_description = /** @type {(inputs: Components_Not_Found_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该页面已下架——或者从未在此上线。请检查网址，或返回安全区域。`)
};

const zh_hk2_components_not_found_default_description = /** @type {(inputs: Components_Not_Found_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此頁面已下架 — 又或者從未在此出現過。請檢查網址，或返回安全位置。`)
};

const ko_kr2_components_not_found_default_description = /** @type {(inputs: Components_Not_Found_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 페이지는 삭제되었거나 처음부터 존재하지 않았습니다. 주소를 확인하거나 홈으로 돌아가세요.`)
};

const ru_ru2_components_not_found_default_description = /** @type {(inputs: Components_Not_Found_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эта страница снята с торгов — или никогда здесь и не торговалась. Проверьте адрес или вернитесь на главную.`)
};

const es_419_components_not_found_default_description = /** @type {(inputs: Components_Not_Found_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta página fue deslistada, o nunca se negoció aquí. Revisa la dirección o vuelve a terreno seguro.`)
};

/**
* | output |
* | --- |
* | "This page was delisted — or it never traded here in the first place. Check the address, or head back to safety." |
*
* @param {Components_Not_Found_Default_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const components_not_found_default_description = /** @type {((inputs?: Components_Not_Found_Default_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Not_Found_Default_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_components_not_found_default_description(inputs)
	if (locale === "de") return de_components_not_found_default_description(inputs)
	if (locale === "pt-BR") return pt_br2_components_not_found_default_description(inputs)
	if (locale === "tr") return tr_components_not_found_default_description(inputs)
	if (locale === "zh-CN") return zh_cn2_components_not_found_default_description(inputs)
	if (locale === "zh-HK") return zh_hk2_components_not_found_default_description(inputs)
	if (locale === "ko-KR") return ko_kr2_components_not_found_default_description(inputs)
	if (locale === "ru-RU") return ru_ru2_components_not_found_default_description(inputs)
	return es_419_components_not_found_default_description(inputs)
});